import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { usePublicData } from "@/lib/publicData";
import { PageHero, Container, Reveal, CtaBand, SERVICE_ICONS } from "@/components/public/parts";
import { Heart, ArrowRight } from "lucide-react";

export default function Services() {
  const data = usePublicData();
  const page = (data?.pages || {}).services || {};
  return (
    <>
      <Seo title={page.seo_title || "Services | Love For Mankind"} description={page.meta_description} path="/services" />
      <PageHero eyebrow="What We Do" title={page.h1 || "Support Services Built Around Each Person"} sub="Verified Love For Mankind services delivered with compassion across Ohio." breadcrumbs={[{ label: "Home", to: "/" }, { label: "Services" }]} />
      <Container className="py-16 lg:py-24">
        <div className="grid md:grid-cols-2 gap-6">
          {(data?.services || []).map((svc, i) => {
            const Icon = SERVICE_ICONS[svc.icon] || Heart;
            return (
              <Reveal key={svc.id} delay={i * 0.05}>
                <Link to={`/services/${svc.slug}`} className="group flex gap-5 rounded-2xl border border-border bg-card p-6 hover:border-primary/40 transition-colors h-full" data-testid="services-item">
                  <div className="w-14 h-14 rounded-2xl bg-secondary flex items-center justify-center shrink-0 group-hover:bg-primary transition-colors"><Icon className="w-7 h-7 text-primary group-hover:text-primary-foreground transition-colors" /></div>
                  <div>
                    <h2 className="font-heading text-xl font-semibold">{svc.name}</h2>
                    <p className="text-[15px] text-muted-foreground mt-2 leading-[1.65] line-clamp-3">{svc.description}</p>
                    <span className="inline-flex items-center gap-1.5 text-primary font-semibold text-sm mt-3">Learn more <ArrowRight className="w-4 h-4" /></span>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </Container>
      <CtaBand />
    </>
  );
}
